/**
 * @desc router
 * @author YongZhang<zhangyong06@baidu.com>
 * @file routerMap
 */
// import NotFound from '@/components/NotFound.vue';
// import Home from '@/pages/law-info/views/index.vue';
import Login from '@/view/Login';
import Filldata from '@/view/Filldata';
import Introduce from '@/view/Introduce';
import ClaimLawyer from '@/pages/claim-lawyer/views/index.vue';
import LawyerInfoConfirm from '@/pages/lawyer-info-confirm/views/index.vue';
import {getRouterBase} from '@/utils/basePath';
// import Agreement from '@/views/agreement/index.vue';
// auth: 'in'带左侧菜单， auth: 'out' 不带左侧菜单
export default {
    mode: 'history',
    base: getRouterBase(),
    routes: [
        {
            path: '/login',
            name: 'login',
            meta: {auth: 'in'},
            component: Login
        },
        {
            path: '/filldata',
            name: 'filldata',
            component: Filldata
        },
        {
            path: '/introduce-bjh',
            name: 'introduce-bjh',
            component: Introduce
        },
        {
            path: '/claim-lawyer',
            name: 'claim-lawyer',
            meta: {auth: 'out'},
            component: ClaimLawyer
        },
        {
            path: '/lawyer-info-confirm',
            name: 'lawyer-info-confirm',
            meta: {auth: 'out'},
            component: LawyerInfoConfirm
        },
        {
            path: '*',
            redirect: to => ({
                name: 'login'
            })
        }
    ]
};
